import 'UI/Widget/Forms/Control/Element'

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control")

/**
 * @class
 * @extends UI.Widget.Forms.Control.Element
 */
UI.Widget.Forms.Control.MultiSelect = Class(UI.Widget.Forms.Control.Element, /** @lends UI.Widget.Forms.Control.MultiSelect.prototype */ {
    source: [],

    createElement () {
        let source = []
        const value = this.$control.attr("value")
        const title = this.$control.attr("title")

        if (this.$control.attr("source")) {
            eval("source = this.parent." + this.$control.attr("source") + "")
        }

        this.source = source

        this.$element = UI.Template.$render("UI/Widget/Forms/Control/MultiSelect/Control", {
            source: this.source,
            value,
            title
        })

        const toggle = evt => {
            evt.stopPropagation()
            $('.editor', this.$element).toggleClass('hidden')
            $('.display', this.$element).toggleClass('hidden')
        }

        $('.edit', this.$element).click(toggle)
        $('.close', this.$element).click(toggle)
    },

    insertTitle () {
        // todo Временная заглшка.
        // рефакторинг контрола, изменить имена опций из атрибутов контрола (title, value). Пересекаются с опциями родительского класса.
    },

    insertElement () {
        this.ParentCall()

        const self = this
        const adjustValue = this.getAdjustValueHelper()

        this.$element.on('change', 'input[type="checkbox"]', () => {
            const value = []

            this.$('input:checked').each(function () {
                if (this.checked) {
                    value.push(adjustValue(this.value))
                }
            })

            this.setValue(value)
            this.updateElement(value)
        })
    },

    getAdjustValueHelper () {
        let adjustValue = _.get(this.parent, this.$control.attr('adjust-value'))

        if (!_.isFunction(adjustValue)) adjustValue = _.identity

        return _.partialRight(adjustValue, _, this)
    },

    updateElement (value) {
        if (!Array.isArray(value)) {
            value = []
        }

        const adjustValue = this.getAdjustValueHelper()

        this.$("input").each(function () {
            this.checked = !!~value.indexOf(adjustValue(this.value))
        })

        const titles = []
        const valueProp = this.$control.attr("value")
        const titleProp = this.$control.attr("title")

        value.forEach(val => {
            const row = _.find(this.source, row => row[ valueProp ] === val)

            row && titles.push(row[ titleProp ])
        })

        this.$('.values').html(titles.join(', '))
    },

    editMode () {
        this.ParentCall()
        this.$('input').prop('disabled', false)
        this.$('.edit, .close, .remove').show()
    },
    viewMode () {
        this.ParentCall()
        this.$('input').prop('disabled', true)
        this.$('.edit, .close, .remove').hide()
    },
})
